// Auto-generated education routes
// Generated at: 2026-07-28T11:44:39.311Z

import type { IRouteMeta } from '@app/interfaces/dtos/IRouteMeta'
import { addRoutePrefix } from '@generator/config/route-prefix'
import { FilterType } from '@studyportals/omnisearch-interfaces'
import { SearchType } from '@domain/enums/SearchType'

export interface GeneratedRoute {
  path: string
  component: string
  name: string
  meta: IRouteMeta
  beforeEnter?: string
}

export const regexPatterns = {
  "lv": "master|bachelor|phd|distance-learning|course",
  "di": "law|engineering-technology|humanities|medicine-health|natural-sciences-mathematics|applied-sciences-professions|social-sciences|business-management|computer-science-it|agriculture-forestry|journalism-media|hospitality-leisure-sports|environmental-studies-earth-sciences|arts-design-architecture|education-training|economics|education|architecture|project-management|industrial-systems-engineering|environmental-engineering|civil-engineering-construction|bio-biomedical-engineering|biomedical-science|biomedicine|chemical-engineering|materials-science|materials-science-engineering|electrical-engineering|aerospace-engineering|physics|mechanical-engineering|mathematics|business-administration|chemistry|earth-sciences|european-law|patent-intellectual-property-law|applied-mathematics|industrial-design|family-consumer-science|library-science|military-science|social-work|design|area-cultural-studies|visual-arts|film-studies|film-photography-media|archaeology|communication-studies|communication-science|anthropology|ethnic-studies|history|geography|gender-sexuality-studies|language-studies|international-relations|psychology|sociology|biology|astronomy-space-sciences|electronics-embedded-technology|philosophy|philosophy-ethics|international-law|entrepreneurship|finance|marketing|management-studies|management-organization-leadership|public-health|medicine|human-medicine|accounting|energy-engineering|energy-power-engineering|special-education|educational-research|theology-and-religious-studies|religious-studies-theology|dentistry|public-administration|international-development|organisational-behaviour|music|physiotherapy|pharmacy|veterinary-medicine|information-technology|informatics-information-technology|criminal-law|econometrics|human-resource-management|forensic-science|nursing|civil-private-law|public-law|biotechnology|toxicology|soil-science|geology|hydrology-water-management|climate-studies-meteorology|biodiversity-conservation|sustainable-development|environmental-economics-policy|geographical-information-systems|nutrition-dietetics|fashion-textiles-and-luxury-goods|supply-chain-management-logistics|sports-management|business-law|legal-studies|master-of-laws|natural-sciences|financial-mathematics|microbiology|molecular-sciences|neuroscience|statistics|complementary-alternative-medicine|health-administration|health-management|health-sciences|midwifery|agribusiness|auditing|business-intelligence|business-intelligence-analytics|commerce|corporate-communication|corporate-social-responsibility|executive-mba|forensic-accounting|innovation-management|international-business|master-in-business-administration|master-in-management|retail-management|risk-management|strategic-management|taxation|engineering-management|technology-management|transport-management|automotive-engineering|general-engineering-technology|marine-engineering|mechatronics|mining-oil-gas|robotics|sustainable-energy|transportation-engineering|art-history|fashion-design|graphic-design|interior-design|landscape-architecture|musicology|music-history|user-experience-design|ancient-history|christian-studies|creative-writing|general-studies|general-studies-classics|islamic-studies|liberal-arts|literature|modern-history|american-and-australasian-studies|american-studies|cognitive-science|cognitive-sciences|criminology|european-studies|public-policy|business-information-systems|game-design|video-games-animation|computer-sciences|data-science-big-data|health-informatics|human-computer-interaction|web-technologies-cloud-computing|environmental-management|natural-resource-management|adult-education|coaching|school-counselling|counselling|educational-psychology|teaching|emergency-disaster-management|food-science|food-sciences|museum-studies|agriculture|animal-science|animal-sciences|marine-science|marine-studies|forestry|horticulture-and-crop-science|horticulture|botany|plant-crop-science|journalism|media-management|media-studies-mass-media|public-relations|translation-interpreting|hospitality-management|culinary-arts|event-management|ecology|environmental-sciences|political-science|sport-and-exercise-science|sports-sciences|drama|theatre-dance|tourism-leisure|terrorism-security|real-estate-property-management|digital-media|digital-communication|cyber-security|digital-marketing|actuarial-science|bioinformatics-biostatistics|bioinformatics|biochemistry|urban-planning|software-engineering|artificial-intelligence|machine-learning|linguistics|early-childhood-education|genetics|clinical-psychology|counselling-psychology|communications-engineering|criminal-justice|construction-management|kinesiology|speech-pathology|stem-education|medical-imaging|childhood-studies|primary-education|educational-leadership|sound-engineering|occupational-health-and-safety|management-of-creative-industries|it-management|pharmacology|instructional-design|operations-and-quality-management|nanoscience-and-nanotechnology|teaching-english-as-a-foreign-language|teaching-english|secondary-education|art-education|gerontology|banking|banking-and-investment|higher-education|community-development|esl|leadership|nuclear-engineering|epidemiology|physiology|literacy-education|health-education|immunology|marketing-management|music-composition|music-performance|fine-arts|information-systems|optometry|social-policy|financial-technology|italian-studies|fashion-management|occupational-therapy|pathology|forensic-psychology|asian-studies|developmental-psychology|social-psychology|food-technology|slavic-studies|diplomacy|art-therapy|african-studies|middle-eastern-studies|publishing|financial-management|production-and-manufacturing-engineering|anatomy|structural-engineering|french-studies|german-and-scandinavian-studies|advertising|computational-mathematics|zoology|operations-research|insurance|prosthetics-and-orthotics|oceanography|aviation-studies|iberian-studies|ceramics-and-sculpture|british-studies|painting-and-drawing|art-and-craft|classics|investment|dance|animation|photography|ethics|data-analytics",
  "ci": "afghanistan|aland-islands|albania|algeria|american-samoa|andorra|angola|anguilla|antigua-and-barbuda|argentina|armenia|aruba|australia|austria|azerbaijan|bahamas|bahrain|bangladesh|barbados|belarus|belgium|belize|benin|bermude|bhutan|bolivia|bonaire-sint-eustatius-and-saba|bosnia-and-herzegovina|botswana|brazil|british-virgin-islands|brunei|bulgaria|burkina-faso|burundi|cambodia|cameroon|canada|cape-verde|cayman-islands|central-african-republic|chad|chile|china|colombia|comoros|democratic-republic-of-the-congo|congo|cook-islands|costa-rica|cte-divoire|croatia|cuba|curaao|cyprus|czech-republic|denmark|djibouti|dominica|dominican-republic|ecuador|egypt|el-salvador|equatorial-guinea|eritrea|estonia|swaziland|ethiopia|faroe-islands|fiji|finland|france|french-guiana|french-polynesia|gabon|gambia|georgia|germany|ghana|greece|greenland|grenada|guadeloupe|guam|guatemala|guinea|guinea-bissau|guyana|haiti|honduras|hong-kong|hungary|iceland|india|indonesia|iran|iraq|ireland|isle-of-man|israel|italy|jamaica|japan|jordan|kazakhstan|kenya|kiribati|kosovo|kuwait|kyrgyzstan|laos|latvia|lebanon|lesotho|liberia|libya|liechtenstein|lithuania|luxembourg|macao|madagascar|malawi|malaysia|maldives|mali|malta|marshall-islands|martinique|mauritania|mauritius|mexico|micronesia-federated-states-of|moldova|monaco|mongolia|montenegro|montserrat|morocco|mozambique|myanmar|namibia|nauru|nepal|netherlands|new-caledonia|new-zealand|nicaragua|niger|nigeria|niue|north-korea|macedonia|northern-cyprus|northern-mariana-islands|norway|oman|pakistan|palau|palestinian-territory-occupied|panama|papua-new-guinea|paraguay|peru|philippines|poland|portugal|puerto-rico|qatar|runion|romania|russia|rwanda|saint-barthlemy|saint-kitts-and-nevis|saint-lucia|saint-pierre-and-miquelon|saint-vincent-and-the-grenadines|samoa|san-marino|so-tom-and-prncipe|saudi-arabia|senegal|serbia|seychelles|sierra-leone|singapore|sint-maarten|slovakia|slovenia|solomon-islands|somalia|south-africa|south-korea|south-sudan|spain|sri-lanka|sudan|suriname|sweden|switzerland|syria|taiwan|tajikistan|tanzania|thailand|timor-leste|togo|tonga|trinidad-and-tobago|tunisia|turkey|turkmenistan|turks-and-caicos-islands|tuvalu|uganda|ukraine|united-arab-emirates|united-kingdom|united-states|united-states-virgin-islands|uruguay|uzbekistan|vanuatu|venezuela|vietnam|western-sahara|yemen|zambia|zimbabwe",
  "ae": "western-australia|south-australia|northern-territory|victoria|tasmania|queensland|new-south-wales|australian-capital-territory|wales|scotland|n-ireland|england|arkansas|washington-dc|delaware|florida|georgia|kansas|louisiana|maryland|missouri|mississippi|north-carolina|oklahoma|south-carolina|tennessee|texas|west-virginia|alabama|connecticut|iowa|illinois|indiana|maine|michigan|minnesota|nebraska|new-hampshire|new-jersey|new-york|ohio|rhode-island|vermont|wisconsin|california|colorado|new-mexico|nevada|utah|arizona|idaho|montana|north-dakota|oregon|south-dakota|washington|wyoming|hawaii|alaska|kentucky|massachusetts|pennsylvania|virginia",
  "rg": "europe|asia|africa|north-america|oceania|south-america",
  "dur": "less-than-1-month|1-to-3-months|more-than-3-months|less-than-1-year|1-year|1-5-years|less-than-2-years|2-years|2-5-years|3-years|3-5-years|4-years|more-than-2-years|more-than-4-years",
  "at": "on-campus|online|blended",
  "de": "full-time|part-time",
  "tr": "affordable",
  "dg": "msc|ma|mba|llm|mphil|mlitt|mres|med|meng|postgraduate-diploma|postgraduate-certificate|pre-master|bsc|ba|bba|llb|beng|associate-degree|graduate-certificate|graduate-diploma|prebachelor|adiploma|ph-d|dba|doctorate|certificate",
  "sps": "executive-programmes|joint-programmes|erasmus-mundus",
  "ef": "academic-course|conference|summer-school|winter-school|semester-abroad|skill"
}

const applyRegexPatterns = (template: string): string => template.replace(/:([A-Za-z_]\w*)/g, (segment, key) => {
  const pattern = regexPatterns[key as keyof typeof regexPatterns]
  return pattern ? `:${key}(${pattern})` : segment
})

const programmeRouteTemplates: GeneratedRoute[] = [
  {
    path: "/search/:lv",
    component: "~/pages/_gen.vue",
    name: "Portal",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL] }
  },
  {
    path: "/search/:lv/:di",
    component: "~/pages/_gen.vue",
    name: "Discipline",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:ci",
    component: "~/pages/_gen.vue",
    name: "Country",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "Area",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:rg",
    component: "~/pages/_gen.vue",
    name: "Continent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dur",
    component: "~/pages/_gen.vue",
    name: "Duration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION] }
  },
  {
    path: "/search/:lv/:de",
    component: "~/pages/_gen.vue",
    name: "Density",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES] }
  },
  {
    path: "/search/:lv/:at",
    component: "~/pages/_gen.vue",
    name: "Attendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:tr",
    component: "~/pages/_gen.vue",
    name: "TuitionFee",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/:lv/:dg",
    component: "~/pages/_gen.vue",
    name: "Degree",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE] }
  },
  {
    path: "/search/:lv/:sps",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammes",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/:lv/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:di/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DisciplineArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DisciplineContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:tr/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFee",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:dg/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDegreeType",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:sps/:di",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesDiscipline",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:de/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDensity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryTuitionFee",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeType",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:sps/:ci",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dg/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:dg/:dur",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION] }
  },
  {
    path: "/search/:lv/:dg/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES] }
  },
  {
    path: "/search/:lv/:dg/:tr",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFee",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/:lv/:dg/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceDegreeType",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:dg/:sps",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammes",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/:lv/:dg/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dg/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:dg/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeCountryTuitionFee",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dg/:tr/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTuitionFeeArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:dg/:tr/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeDensity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.DENSITIES] }
  },
  {
    path: "/search/:lv/:dg/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:dg/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceDegreeType",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:dg/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dg/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAttendanceDiscipline",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:dg/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:dg/:sps/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:dur/:rg",
    component: "~/pages/_gen.vue",
    name: "DurationContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dur/:ae",
    component: "~/pages/_gen.vue",
    name: "DurationArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:de/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:de/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityContinentRoute",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:de/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:de/:di/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:de/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:dur/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DensityAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:at/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AttendanceCountryArea",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/:lv/:at/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:at/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:at/:dur",
    component: "~/pages/_gen.vue",
    name: "AttendanceDuration",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DURATION] }
  },
  {
    path: "/search/:lv/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeContinentRoute",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/:lv/:tr/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeAttendance",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/:lv/:sps/:rg",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesContinent",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.CONTINENT] }
  },
  {
    path: "/search/:lv/:di/:ef",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalForm",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/:lv/:di/:ef/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormCountry",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM, FilterType.COUNTRY] }
  },
  {
    path: "/search/:lv/:ci/:ef",
    component: "~/pages/_gen.vue",
    name: "CountryEducationalForm",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/:lv/:ct",
    component: "~/pages/_gen.vue",
    name: "City",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CITY] }
  },
  {
    path: "/search/:lv/:di/:ct",
    component: "~/pages/_gen.vue",
    name: "DisciplineCity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CITY] }
  },
  {
    path: "/search/:lv/:ci/:ae/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryAreaCity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA, FilterType.CITY] }
  },
  {
    path: "/search/:lv/:ci/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryCity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.CITY] }
  },
  {
    path: "/search/:lv/:oi",
    component: "~/pages/_gen.vue",
    name: "Organisation",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/:lv/:di/:oi",
    component: "~/pages/_gen.vue",
    name: "DisciplineOrganisation",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/:lv/:ci/:oi",
    component: "~/pages/_gen.vue",
    name: "CountryOrganisation",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.ORGANISATIONS] }
  }
]

const universityRouteTemplates: GeneratedRoute[] = [
  {
    path: "/search/universities/:lv",
    component: "~/pages/_gen.vue",
    name: "PortalUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL] }
  },
  {
    path: "/search/universities/:lv/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:rg",
    component: "~/pages/_gen.vue",
    name: "ContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dur",
    component: "~/pages/_gen.vue",
    name: "DurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION] }
  },
  {
    path: "/search/universities/:lv/:de",
    component: "~/pages/_gen.vue",
    name: "DensityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES] }
  },
  {
    path: "/search/universities/:lv/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:tr",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/universities/:lv/:dg",
    component: "~/pages/_gen.vue",
    name: "DegreeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE] }
  },
  {
    path: "/search/universities/:lv/:sps",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/universities/:lv/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:di/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DisciplineAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DisciplineContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:tr/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:dg/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDegreeTypeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:sps/:di",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesDisciplineUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:de/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDensityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryTuitionFeeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:sps/:ci",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dg/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:dg/:dur",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION] }
  },
  {
    path: "/search/universities/:lv/:dg/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/universities/:lv/:dg/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceDegreeTypeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:dg/:sps",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/universities/:lv/:dg/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dg/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeCountryTuitionFeeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTuitionFeeAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeDensityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.DENSITIES] }
  },
  {
    path: "/search/universities/:lv/:dg/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:dg/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceDegreeTypeUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:dg/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dg/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAttendanceDisciplineUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:dg/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:dg/:sps/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:dur/:rg",
    component: "~/pages/_gen.vue",
    name: "DurationContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dur/:ae",
    component: "~/pages/_gen.vue",
    name: "DurationAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:de/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:de/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityContinentRouteUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:de/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:de/:di/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:de/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:dur/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DensityAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:at/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AttendanceCountryAreaUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/universities/:lv/:at/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:at/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:at/:dur",
    component: "~/pages/_gen.vue",
    name: "AttendanceDurationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DURATION] }
  },
  {
    path: "/search/universities/:lv/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeContinentRouteUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/universities/:lv/:tr/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeAttendanceUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/universities/:lv/:sps/:rg",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesContinentUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.CONTINENT] }
  },
  {
    path: "/search/universities/:lv/:di/:ef",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/universities/:lv/:di/:ef/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormCountryUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM, FilterType.COUNTRY] }
  },
  {
    path: "/search/universities/:lv/:ci/:ef",
    component: "~/pages/_gen.vue",
    name: "CountryEducationalFormUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/universities/:lv/:ct",
    component: "~/pages/_gen.vue",
    name: "CityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CITY] }
  },
  {
    path: "/search/universities/:lv/:di/:ct",
    component: "~/pages/_gen.vue",
    name: "DisciplineCityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CITY] }
  },
  {
    path: "/search/universities/:lv/:ci/:ae/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryAreaCityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA, FilterType.CITY] }
  },
  {
    path: "/search/universities/:lv/:ci/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryCityUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.CITY] }
  },
  {
    path: "/search/universities/:lv/:oi",
    component: "~/pages/_gen.vue",
    name: "OrganisationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/universities/:lv/:di/:oi",
    component: "~/pages/_gen.vue",
    name: "DisciplineOrganisationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/universities/:lv/:ci/:oi",
    component: "~/pages/_gen.vue",
    name: "CountryOrganisationUniversity",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/universities/:lv/rankings",
    component: "~/pages/_gen.vue",
    name: "PortalUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:rg",
    component: "~/pages/_gen.vue",
    name: "ContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur",
    component: "~/pages/_gen.vue",
    name: "DurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de",
    component: "~/pages/_gen.vue",
    name: "DensityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg",
    component: "~/pages/_gen.vue",
    name: "DegreeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:sps",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:ae/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:rg/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDegreeTypeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:sps/:di",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesDisciplineUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDensityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryTuitionFeeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:sps/:ci",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:dur",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceDegreeTypeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:sps",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:ci/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:rg/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeCountryTuitionFeeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTuitionFeeAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeDensityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.DENSITIES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceDegreeTypeUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAttendanceDisciplineUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dg/:sps/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur/:rg",
    component: "~/pages/_gen.vue",
    name: "DurationContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur/:ae",
    component: "~/pages/_gen.vue",
    name: "DurationAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityContinentRouteUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:ci/:di",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:ae/:di",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:rg/:di",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:dur/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DensityAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AttendanceCountryAreaUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.AREA, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:rg/:di",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:ci/:di",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:at/:dur",
    component: "~/pages/_gen.vue",
    name: "AttendanceDurationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DURATION, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeContinentRouteUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:tr/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeAttendanceUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:sps/:rg",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesContinentUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.CONTINENT, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ef/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ef/:ci/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormCountryUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM, FilterType.COUNTRY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:ef",
    component: "~/pages/_gen.vue",
    name: "CountryEducationalFormUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.EDUCATIONAL_FORM, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ct",
    component: "~/pages/_gen.vue",
    name: "CityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CITY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ct/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineCityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CITY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:ae/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryAreaCityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA, FilterType.CITY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryCityUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.CITY, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:oi",
    component: "~/pages/_gen.vue",
    name: "OrganisationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ORGANISATIONS, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:oi/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineOrganisationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.ORGANISATIONS, FilterType.SORTING] }
  },
  {
    path: "/search/universities/:lv/rankings/:ci/:oi",
    component: "~/pages/_gen.vue",
    name: "CountryOrganisationUniversityRanking",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.ORGANISATIONS, FilterType.SORTING] }
  }
]

const scholarshipRouteTemplates: GeneratedRoute[] = [
  {
    path: "/search/scholarships/:lv",
    component: "~/pages/_gen.vue",
    name: "PortalScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL] }
  },
  {
    path: "/search/scholarships/:lv/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:rg",
    component: "~/pages/_gen.vue",
    name: "ContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dur",
    component: "~/pages/_gen.vue",
    name: "DurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION] }
  },
  {
    path: "/search/scholarships/:lv/:de",
    component: "~/pages/_gen.vue",
    name: "DensityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES] }
  },
  {
    path: "/search/scholarships/:lv/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:tr",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/scholarships/:lv/:dg",
    component: "~/pages/_gen.vue",
    name: "DegreeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE] }
  },
  {
    path: "/search/scholarships/:lv/:sps",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/scholarships/:lv/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:di/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DisciplineAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DisciplineContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:tr/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDegreeTypeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:sps/:di",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesDisciplineScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:de/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDensityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryTuitionFeeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:sps/:ci",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:dur",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:at",
    component: "~/pages/_gen.vue",
    name: "AttendanceDegreeTypeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:sps",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:dur/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryDegreeTypeDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:dur/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDisciplineDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DURATION, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr/:ci",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeCountryTuitionFeeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "DegreeTuitionFeeAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr/:de",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeDensityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.DENSITIES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeTuitionFeeAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:at/:ci",
    component: "~/pages/_gen.vue",
    name: "CountryAttendanceDegreeTypeScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeAttendanceDisciplineScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeDensityAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:dg/:sps/:at",
    component: "~/pages/_gen.vue",
    name: "DegreeTypeSpecialProgrammesAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DEGREE_TYPE, FilterType.SPECIAL_PROGRAMMES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:dur/:rg",
    component: "~/pages/_gen.vue",
    name: "DurationContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dur/:ae",
    component: "~/pages/_gen.vue",
    name: "DurationAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:de/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:de/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityContinentRouteScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:de/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:de/:di/:ae",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:de/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "DensityDisciplineContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:dur/:de/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineDensityDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DURATION, FilterType.DENSITIES, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:de/:at",
    component: "~/pages/_gen.vue",
    name: "DensityAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DENSITIES, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:at/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:at/:ci/:ae",
    component: "~/pages/_gen.vue",
    name: "AttendanceCountryAreaScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.COUNTRY, FilterType.AREA] }
  },
  {
    path: "/search/scholarships/:lv/:at/:di/:rg",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:at/:di/:ci",
    component: "~/pages/_gen.vue",
    name: "AttendanceDisciplineCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DISCIPLINES, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:at/:dur",
    component: "~/pages/_gen.vue",
    name: "AttendanceDurationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ATTENDANCE, FilterType.DURATION] }
  },
  {
    path: "/search/scholarships/:lv/:tr/:rg",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeContinentRouteScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:tr/:at",
    component: "~/pages/_gen.vue",
    name: "TuitionFeeAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE] }
  },
  {
    path: "/search/scholarships/:lv/:tr/:at/:di",
    component: "~/pages/_gen.vue",
    name: "DisciplineTuitionFeeAttendanceScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.TUITION_FEE, FilterType.ATTENDANCE, FilterType.DISCIPLINES] }
  },
  {
    path: "/search/scholarships/:lv/:sps/:rg",
    component: "~/pages/_gen.vue",
    name: "SpecialProgrammesContinentScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.SPECIAL_PROGRAMMES, FilterType.CONTINENT] }
  },
  {
    path: "/search/scholarships/:lv/:di/:ef",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/scholarships/:lv/:di/:ef/:ci",
    component: "~/pages/_gen.vue",
    name: "DisciplineEducationalFormCountryScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.EDUCATIONAL_FORM, FilterType.COUNTRY] }
  },
  {
    path: "/search/scholarships/:lv/:ci/:ef",
    component: "~/pages/_gen.vue",
    name: "CountryEducationalFormScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.EDUCATIONAL_FORM] }
  },
  {
    path: "/search/scholarships/:lv/:ct",
    component: "~/pages/_gen.vue",
    name: "CityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.CITY] }
  },
  {
    path: "/search/scholarships/:lv/:di/:ct",
    component: "~/pages/_gen.vue",
    name: "DisciplineCityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.CITY] }
  },
  {
    path: "/search/scholarships/:lv/:ci/:ae/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryAreaCityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.AREA, FilterType.CITY] }
  },
  {
    path: "/search/scholarships/:lv/:ci/:ct",
    component: "~/pages/_gen.vue",
    name: "CountryCityScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.CITY] }
  },
  {
    path: "/search/scholarships/:lv/:oi",
    component: "~/pages/_gen.vue",
    name: "OrganisationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/scholarships/:lv/:di/:oi",
    component: "~/pages/_gen.vue",
    name: "DisciplineOrganisationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.DISCIPLINES, FilterType.ORGANISATIONS] }
  },
  {
    path: "/search/scholarships/:lv/:ci/:oi",
    component: "~/pages/_gen.vue",
    name: "CountryOrganisationScholarship",
    meta: { filterTypes: [FilterType.EDUCATION_LEVEL, FilterType.COUNTRY, FilterType.ORGANISATIONS] }
  }
]

const buildRoutesFromTemplates = (templates: GeneratedRoute[], searchType: SearchType): GeneratedRoute[] => templates.flatMap(route => [
  {
    ...route,
    meta: { ...route.meta, searchType },
    path: applyRegexPatterns(route.path)
  },
  {
    ...route,
    meta: { ...route.meta, searchType },
    name: `${route.name}OmniSearch`,
    path: applyRegexPatterns(addRoutePrefix(route.path))
  }
])

export const programmeRoutes: GeneratedRoute[] = buildRoutesFromTemplates(programmeRouteTemplates, SearchType.PROGRAMME_SEARCH)
export const universityRoutes: GeneratedRoute[] = buildRoutesFromTemplates(universityRouteTemplates, SearchType.UNIVERSITY_SEARCH)
export const scholarshipRoutes: GeneratedRoute[] = buildRoutesFromTemplates(scholarshipRouteTemplates, SearchType.SCHOLARSHIP_SEARCH)

export const getUnifiedRoutes = (): GeneratedRoute[] => ([
  ...programmeRoutes,
  ...universityRoutes,
  ...scholarshipRoutes
])

export const unifiedRoutes: GeneratedRoute[] = getUnifiedRoutes()

// Route Statistics
export const routeStats = {
  total: 600
}
